import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select } from "antd";
import reportsStatisticsActions from "../../../redux/reportsStatistics/actions";
import { useProjectState } from "../../../context/stateContext";
import DatePickerComponent from "../../Common/DatePicker/DatePicker";
import "./index.css";

const { Option } = Select;
const { getReporstStatistics } = reportsStatisticsActions;
const ReportsInfoActions = () => {
  const {
    selectedOrganization,
    allSectedRestaurants,
    setAllSelectedRestaurants,
    startDate,
    endDate,
  } = useProjectState();
  const dispatch = useDispatch();
  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );
  const organizationId = defaultOrganization[0]?.id;
  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;

  useEffect(() => {
    if (defaultOrganization.length > 0) {
      setAllSelectedRestaurants([
        defaultOrganization[0]?.defaultTouchSaleRestaurantId,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        organizationId !== undefined &&
        defaultTouchSaleRestaurantId !== undefined
      ) {
        dispatch(
          getReporstStatistics(
            organizationId,
            allSectedRestaurants[0],
            startDate,
            endDate
          )
        );
      }
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, organizationId, allSectedRestaurants]);

  const handleOnChangeRestaurant = (restaurant) => {
    setAllSelectedRestaurants([restaurant]);
  };

  return (
    <>
      <div className="reports-info-action-buttons-container">
        {defaultOrganization[0]?.multipleRestaurants && (
          <Select
            showSearch={false}
            virtual={false}
            key="reportsInfoRestaurantSelect"
            placeholder="Изберете ресторант"
            onChange={handleOnChangeRestaurant}
            value={allSectedRestaurants}
            className="reports-info-action-buttons"
          >
            {restaurants?.map((restaurant, index) => (
              <Option
                key={restaurant.id}
                value={restaurant.id}
                className="reports-info-select-option"
              >
                {restaurant.name}
              </Option>
            ))}
          </Select>
        )}
        <DatePickerComponent />
      </div>
    </>
  );
};

export default ReportsInfoActions;
